import React from 'react';
import BrandName from '../../../images/brandName.png';
import BurgergerMenu from '../nav/BurgerMenu';

const TopNav = () => {
  return (
    <div className='topNavbar'>
      <div className='brandName'>
        <img src={BrandName} alt='brandName' />
      </div>
      <div className='topNavbar-burger'>
        <BurgergerMenu />
      </div>
    </div>
  );
};

export default TopNav;
